import React, { PureComponent } from 'react';
// Components
import styles from './chart.scss';
const SPACE = 100;
interface ChartXAxisProps {
  minX: number;
  maxX: number;
  width: number;
  range: [number, number];
}
export default class ChartXAxis extends PureComponent<ChartXAxisProps> {
  render() {
    const { minX, maxX, range, width } = this.props;

    const totalTime = maxX - minX;
    const startTime = range[0] * totalTime;
    const endTime = range[1] * totalTime;
    const rangeTime = endTime - startTime;
    const count = Math.floor(width / SPACE);
    let labels = [];
    for (let i = 0; i < count; i++) {
      let ms = Math.round(startTime + (i / count) * rangeTime);
      const min = Math.round(ms / (1000 * 60));
      const sec = Math.round(ms / 1000) % 60;
      labels.push(
        <div key={i} className={styles.label}>
          {min < 10 && '0'}
          {min}:{sec < 10 && '0'}
          {sec}.{Math.round((ms % 1000).toString().slice(0, 2))}
        </div>
      );
    }

    return <div className={styles.xAxis}>{labels}</div>;
  }
}
